export default {
  'exclamation': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M11 2h2v16h-2V2zM11 20h2v2h-2v-2z"/>`
  }
}
